
import Autocomplete from '@/components/Autocomplete.vue';
import FilterText from '@/components/filters/FilterText.vue';

export default FilterText.extend({
	components: { Autocomplete },
	props: {
		value: {
			type: String,
			required: true,
			default: '',
		}
	},
	computed: {
		autocompleteUrl(): string { return this.definition.metadata as string; },
		modelvalue: {
			get(): string { return this.value; },
			set(v: string) { this.e_input(v); }
		}
	},
});

